import * as React from 'react';
import { ShowGreaterOrEqualTo, ShowLessThan } from '../../atom/Show';
export var ComponentSwitch = function ComponentSwitch(_ref) {
  var breakpoint = _ref.breakpoint,
      showLessThan = _ref.showLessThan,
      showGreaterOrEqualTo = _ref.showGreaterOrEqualTo;
  return React.createElement(React.Fragment, null, React.createElement(ShowLessThan, {
    breakpoint: breakpoint
  }, showLessThan), React.createElement(ShowGreaterOrEqualTo, {
    breakpoint: breakpoint
  }, showGreaterOrEqualTo));
};
ComponentSwitch.defaultProps = {
  breakpoint: 'SM'
};